import { schema } from 'normalizr';

export const address = new schema.Entity('addresses');
export const customerCredit = new schema.Entity('customerCredits');
export const paymentMethod = new schema.Entity('paymentMethods');
export const person = new schema.Entity('people');
export const referralCoupon = new schema.Entity('referralCoupons');
export const region = new schema.Entity('regions');
export const service = new schema.Entity('services');
export const user = new schema.Entity('users');

export const selectedAdditionalService = new schema.Entity(
  'selectedAdditionalServices'
);

export const booking = new schema.Entity('bookings', {
  address,
  person,
  service,
  selectedAdditionalServices: [selectedAdditionalService]
});

export const customer = new schema.Entity('customers', {
  activePaymentMethod: paymentMethod,
  primaryAddress: address,
  primaryPerson: person
});

export const faqQuestion = new schema.Entity('faqQuestions');

export const faqCategory = new schema.Entity('faqCategories', {
  questions: [faqQuestion]
});



// WEBPACK FOOTER //
// ./src/schemas.js